module.exports = __webpack_public_path__ + "img/toys.230d4070.svg";